<!--
 * @Author: your name
 * @Date: 2020-10-27 16:31:00
 * @LastEditTime: 2020-11-03 11:59:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ShopExpressEdition/src/components/advisory/advisoryDetail/detailTitle.vue
-->
<template>
  <div class="detailTitle">
    <div class="title" :class="{check: !check}">
      <el-checkbox
        v-if="isshowcheck == 1"
        :checked="check"
        @change="checkBoxChange($event, prop)"
        >{{ title }}</el-checkbox
      >
      <span v-else>{{ title }}</span>
    </div>
    <slot name="print"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: [String],
    tips: [String, Number, Object, Array],
    check: {
      type: Boolean,
      default: true
    },
    isshowcheck: {
      type: Boolean,
      default: true
    },
    prop: {
      type: String,
      default: ''
    }
  },
  methods: {
    checkBoxChange(val, prop) {
      if (prop) {
        this.$emit('changeRecommandProduct', {
          val,
          prop
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.detailTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fafafa;
  height: 40px;
  box-sizing: border-box;
  padding-left: 20px;
  .title {
    margin-right: 200px;
    font-size: 16px;
    color: #4b90ff;
    font-weight: bold;
  }
  .check {
    color: #333;
  }
  .tips {
    font-size: 16px;
    color: #ffb03e;
  }
}
</style>
